import {PATHS} from "./paths";

/**
 * Ссылка сброса пароля из письма открывается и при живой сессии (#1342): человек
 * мог забыть пароль на телефоне, а в браузере ноутбука остаться залогиненным.
 * Раньше гард уводил его в /app и терял `?token=`. Пропускаем только
 * `/reset-password` с токеном; после успешного сброса форма сама выходит из
 * сессии (ResetTokenForm).
 */
export function allowsAuthenticated(pathname: string, search: string): boolean {
    if (pathname !== PATHS.resetPassword) return false;
    const token = (new URLSearchParams(search).get("token") ?? "").trim();
    return token.length > 0;
}
